import styled, { css } from 'styled-components'

import { Colors, Spacing } from 'cio-design-library/design-tokens'
import { Media } from 'builder/styles/media'

import { Icon20 } from 'builder/components/Icon'
import Typography, { FontWeights } from 'builder/styles/typography'
import { BannerInfoProps } from './types'

export const Container = styled.div<Pick<BannerInfoProps, 'theme'>>`
  display: flex;
  gap: ${Spacing.S};
  justify-content: center;

  color: ${Colors.Green70};
  padding: ${Spacing.S} ${Spacing.XS};
  border-radius: ${Spacing['2XS']};
  background-color: ${Colors.Green10};

  ${Media.Phone`
    width: 100%;
    padding: ${Spacing.XS} ${Spacing.S};
  `}

  ${({ theme }) =>
    theme === 'resume-writing' &&
    css`
      color: ${Colors.Blue70};
      background-color: ${Colors.Blue10};
    `}
`

export const Item = styled.div`
  display: flex;
  gap: ${Spacing['4XS']};
`

export const Title = styled.p`
  ${Typography.Caption};
  ${FontWeights.Regular};

  strong {
    ${FontWeights.DemiBold};
  }
`

export const IconContainer = styled.div``

export const Icon = styled(Icon20.Check)`
  color: ${Colors.Green50};
`

export const SwiperContainer = styled.div`
  width: 100%;
  overflow: hidden;

  & .swiper-container {
    width: 100% !important;
    overflow: hidden;
  }

  & .swiper-wrapper {
    display: flex;
    transition-property: transform;
  }

  & .swiper-slide {
    width: 90% !important;
    flex-shrink: 0;
  }
`
